<template>
  <form
    class="o-pin"
    @keyup="inputFocusHelper"
  >
    <div
      v-for="index in pinLength"
      class="o-pin__container"
    >
      <input
        type="password"
        class="o-pin__input--hidden js-hidden"
        :tabIndex="TabIndex.DISABLED"
      >
      <v-input
        :key="`code-${index}`"
        v-model="values[index - 1]"
        :max-length="maxLength"
        :type="type"
        class="o-pin__input"
        @focus="inputFocusSelection"
      ></v-input>
    </div>
  </form>
</template>

<script>
  import { TabIndex } from '@/shared/enums';
  import { inputFocusHelper, inputFocusSelection } from '@/shared/utils';
  import VInput from '../input/index.vue';

  export default {
    components: {
      VInput,
    },
    props: {
      autofocus: {
        type: Boolean,
        default: false,
      },
      pinLength: {
        type: Number,
        default: 4,
      },
      type: {
        type: String,
        default: 'text',
      },
    },
    enums: {
      TabIndex,
    },
    data() {
      return {
        maxLength: 1,
        values: [],
        inputFocusHelper,
        inputFocusSelection,
      };
    },
    watch: {
      values: 'checkCompleted',
    },
    mounted() {
      if (this.autofocus) {
        this.$nextTick(() => this.focus());
      }
    },
    methods: {
      focus() {
        this.$el.querySelector('input:not(.js-hidden)').focus();
      },
      getPinInput() {
        const values = this.values.filter((n) => n).map((val) => val.trim());

        return values.join('');
      },
      checkCompleted() {
        const values = this.values.filter((n) => n).map((val) => val.trim());

        if (values.length === this.pinLength) {
          this.$emit('completed');
        }
      },
    },
  };
</script>
